import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconOrientation$1 = /*@__PURE__*/ proxyCustomElement(class WppIconOrientation extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-orientation", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M5.8 3.59998C5.46863 3.59998 5.2 3.8686 5.2 4.19998C5.2 4.53135 5.46863 4.79998 5.8 4.79998H7C7.33137 4.79998 7.6 4.53135 7.6 4.19998C7.6 3.8686 7.33137 3.59998 7 3.59998H5.8ZM3.2 7.39998C3.2 7.0686 2.93137 6.79998 2.6 6.79998C2.26863 6.79998 2 7.0686 2 7.39998V8.59998C2 8.93135 2.26863 9.19998 2.6 9.19998C2.93137 9.19998 3.2 8.93135 3.2 8.59998V7.39998ZM3.52 9.19998C2.68053 9.19998 2 9.8805 2 10.72V14.88C2 15.7194 2.68053 16.4 3.52 16.4H11.68C12.5195 16.4 13.2 15.7194 13.2 14.88V10.72C13.2 9.8805 12.5195 9.19998 11.68 9.19998H10.2C10.5314 9.19998 10.8 8.93135 10.8 8.59998V7.39998C10.8 7.0686 10.5314 6.79998 10.2 6.79998C9.86863 6.79998 9.6 7.0686 9.6 7.39998V8.59998C9.6 8.93135 9.86863 9.19998 10.2 9.19998H3.52ZM3.2 10.72C3.2 10.5432 3.34327 10.4 3.52 10.4H11.68C11.8567 10.4 12 10.5432 12 10.72V14.88C12 15.0567 11.8567 15.2 11.68 15.2H3.52C3.34327 15.2 3.2 15.0567 3.2 14.88V10.72ZM3.4 4.79998C3.28954 4.79998 3.2 4.88952 3.2 4.99998V5.39998C3.2 5.73135 2.93137 5.99998 2.6 5.99998C2.26863 5.99998 2 5.73135 2 5.39998V4.99998C2 4.22678 2.6268 3.59998 3.4 3.59998H3.8C4.13137 3.59998 4.4 3.8686 4.4 4.19998C4.4 4.53135 4.13137 4.79998 3.8 4.79998H3.4ZM9.6 4.99998C9.6 4.88952 9.51046 4.79998 9.4 4.79998H9C8.66863 4.79998 8.4 4.53135 8.4 4.19998C8.4 3.8686 8.66863 3.59998 9 3.59998H9.4C10.1732 3.59998 10.8 4.22678 10.8 4.99998V5.39998C10.8 5.73135 10.5314 5.99998 10.2 5.99998C9.86863 5.99998 9.6 5.73135 9.6 5.39998V4.99998ZM14 13.2605C14 13.6481 14.3352 13.9562 14.7103 13.8587C16.6028 13.3667 18 11.6465 18 9.59998C18 7.4473 16.4541 5.65568 14.4119 5.27473L14.6556 4.99046C14.8712 4.73887 14.8421 4.36009 14.5905 4.14443C14.3389 3.92878 13.9601 3.95792 13.7444 4.20951L12.5444 5.60951C12.3519 5.83421 12.3519 6.16577 12.5444 6.39046L13.7444 7.79046C13.9601 8.04206 14.3389 8.07119 14.5905 7.85554C14.8421 7.63989 14.8712 7.26111 14.6556 7.00951L14.1777 6.45198C15.6692 6.72392 16.8 8.0299 16.8 9.59998C16.8 11.0638 15.8171 12.2981 14.4752 12.6788C14.2086 12.7545 14 12.9833 14 13.2605Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-orientation-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-orientation", "wpp-icon-orientation-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-orientation-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-orientation-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconOrientation$1);
      }
      break;
  } });
}

const WppIconOrientation = WppIconOrientation$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconOrientation, defineCustomElement };
